export default "__VITE_ASSET__0dc31154__"